import React from "react";

const steps = [
  {
    id: 1,
    icon: "icon-car-1",
    title: "Book Your Vehicle",
    text: "Choose your cab, bus, or tempo traveller and book easily with Sanavi Travels through phone or online enquiry.",
    delay: "200ms",
  },
  {
    id: 2,
    icon: "icon-car-insurance",
    title: "Confirm Your Trip",
    text: "Share travel details like pickup location, destination, date, and passenger count to confirm your booking.",
    delay: "400ms",
  },
  {
    id: 3,
    icon: "icon-car-insurance-1",
    title: "Vehicle Arrives on Time",
    text: "Our well-maintained vehicle with a professional driver arrives at your pickup point on time.",
    delay: "600ms",
  },
  {
    id: 4,
    icon: "icon-satisfaction",
    title: "Enjoy a Safe Journey",
    text: "Travel comfortably with Sanavi Travels and enjoy a smooth, safe, and stress-free journey.",
    delay: "800ms",
  },
];

const HowRentTwo = () => {
  return (
    <section className="how-rent-two ">
      <div className="container">
        <div className="row gutter-y-30">
          {steps.map((step) => (
            <div
              key={step.id}
              className="col-xl-3 col-lg-4 col-md-6 col-sm-12 d-flex py-2"
            >
              <div
                className="how-rent-two__item wow fadeInLeft w-100"
                data-wow-duration="1500ms"
                data-wow-delay={step.delay}
              >
                <div className="how-rent-two__item__top">
                  <div className="how-rent-two__item__icon">
                    <i className={step.icon}></i>
                  </div>
                </div>

                <h4 className="how-rent-two__item__title">
                  {step.title}
                </h4>

                <p className="how-rent-two__item__text">
                  {step.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="how-rent-two__element-one">
        {/* <img src="assets/images/resources/how-1-1.png" alt="Sanavi Travels process" /> */}
      </div>

      <div className="how-rent-two__element-two">
        {/* <img src="assets/images/resources/how-1-2.png" alt="Sanavi Travels booking steps" /> */}
      </div>
    </section>
  );
};

export default HowRentTwo;
